import api from '../token';

export const AlterStatusFornecedor = async (dados) => {
  try {
    const response = await api.post('/alterStatusFornecedor', dados);
    return response.data;
  } catch (error) {
     
    return { success: false, message: error.message };
  }
};



